export function isAndroidAvailable() {
 return typeof Android !== 'undefined'
}

export function getAndroidBaseData() {
 if (!isAndroidAvailable() || !Android.getBaseDataPayloadForProfileFormWebView) {
   return null
 }
 try {
   const raw = Android.getBaseDataPayloadForProfileFormWebView()
   if (!raw) return null
   return JSON.parse(raw)
 } catch (err) {
   console.error('Error parsing Android data:', err)
   return null
 }
}

export function androidLeavePage(doReload = false) {
 if (!isAndroidAvailable() || !Android.leavePage) return
 Android.leavePage(doReload)
}

export function androidOnSubmitSuccess() {
 if (!isAndroidAvailable() || !Android.onSubmitSuccess) return
 Android.onSubmitSuccess()
}

export function registerAndroidLocationCallback(onLocationCoordinatesReceived) {
 if (!isAndroidAvailable()) return
 window.onLocationCoordinatesReceived = onLocationCoordinatesReceived
}

export function registerAndroidBackNav(seekerProfileBackNavigation) {
 if (!isAndroidAvailable()) return
 window.seekerProfileBackNavigation = seekerProfileBackNavigation
}
